module.exports = __webpack_public_path__ + "img/banner_m.5b28f941.png";